import { axiosInstance } from '../axios/axiosConfig';

const baseAPIUrl = "Currency";

// Exchange Rates
export const getSystemCurrencyRate = async () => {
    var result = await axiosInstance.get(`/${baseAPIUrl}/rates`);
    return result.data;
}

// Currency Management
export const getAllCurrencies = async () => {
    var result = await axiosInstance.get(`/${baseAPIUrl}/all`);
    return result.data;
}

export const getCurrencyByCode = async (currencyCode) => {
    var result = await axiosInstance.get(`/${baseAPIUrl}/code/${currencyCode}`);
    return result.data;
}

// System Default Currency
export const getSystemDefaultCurrency = async () => {
    var result = await axiosInstance.get(`/${baseAPIUrl}/default/system`);
    return result.data;
}

export const getSystemDefaultCurrencyCode = async () => {
    var result = await axiosInstance.get(`/${baseAPIUrl}/default/system/code`);
    return result.data;
}

// User Default Currency
export const getUserDefaultCurrency = async () => {
    var result = await axiosInstance.get(`/${baseAPIUrl}/default/user`);
    return result.data;
}

export const getUserDefaultCurrencyCode = async () => {
    var result = await axiosInstance.get(`/${baseAPIUrl}/default/user/code`);
    return result.data;
}

// Supported & Available Currencies
export const getSupportedCurrencyCodes = async () => {
    var result = await axiosInstance.get(`/${baseAPIUrl}/supported`);
    return result.data;
}

export const getAvailableCurrencyCodes = async () => {
    var result = await axiosInstance.get(`/${baseAPIUrl}/available`);
    return result.data;
}

// Admin Operations
export const syncExchangeRates = async () => {
    var result = await axiosInstance.post(`/${baseAPIUrl}/sync`);
    return result.data;
}

export const clearCurrencyCache = async () => {
    var result = await axiosInstance.delete(`/${baseAPIUrl}/cache`);
    return result.data;
}

// Currency Options for UI
export const getCurrencyOptions = async () => {
    var result = await axiosInstance.get(`/${baseAPIUrl}/options`);
    return result.data;
}